export const CHECKLIST_PHASES = {
  BEFORE_CONTACT: "before_contact",
  BEFORE_VISIT: "before_visit",
  INSPECTION: "inspection",
  DOCUMENTS: "documents",
  NEGOTIATION: "negotiation",
  PAYMENT: "payment",
  TRANSFER: "transfer",
  AFTER_PURCHASE: "after_purchase",
};

export const CHECKLIST_IMPORTANCE = {
  ESSENTIAL: "essential",
  RECOMMENDED: "recommended",
  OPTIONAL: "optional",
};

export const CHECKLIST_BUYER_ACTIONS = {
  ASK_DEALER: "ask_dealer",
  INSPECT_VEHICLE: "inspect_vehicle",
  COMPARE_PRICE: "compare_price",
  VERIFY_DOCUMENT: "verify_document",
  AVOID_PAYMENT: "avoid_payment",
  REPORT_ISSUE: "report_issue",
  SAVE_NOTE: "save_note",
};

export const CHECKLIST_DISCLAIMER_ES =
  "Esta checklist es una guía práctica y no reemplaza asesoría legal, revisión documental oficial, peritaje mecánico ni validación ante autoridades o entidades correspondientes.";

export const CHECKLIST_STORAGE_KEYS = {
  general: "automap_checklist_general",
  listingPrefix: "automap_checklist_listing_",
};

export const CHECKLIST_CATEGORIES = {
  DISPONIBILIDAD: "disponibilidad",
  PRECIO: "precio",
  KILOMETRAJE: "kilometraje",
  DOCUMENTOS: "documentos",
  HISTORIAL: "historial",
  PERITAJE: "peritaje",
  CONCESIONARIO: "concesionario",
  PAGOS: "pagos",
  TRASPASO: "traspaso",
  SEGURO_SOAT: "seguro_soat",
  COMPARACION: "comparacion",
};

export const CHECKLIST_PRIORITY = {
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
};

export const CHECKLIST_GUIDE_HREFS = {
  buyingGuide: "/guias/como-comprar-carro-usado",
  checklistGuide: "/guias/checklist-compra-carro-usado",
  inspectionGuide: "/guias/peritaje-carro-usado",
  soatGuide: "/guias/soat-tecnomecanica",
  transferGuide: "/guias/traspaso-vehiculo",
  safetyGuide: "/guias/evitar-estafas-carro-usado",
  hub: "/checklist-compra",
};

export const CHECKLIST_ANALYTICS_EVENTS = {
  PREVIEW_VIEWED: "buyer_checklist_preview_viewed",
  ITEM_CLICKED: "buyer_checklist_item_clicked",
  FULL_OPENED: "buyer_checklist_full_opened",
  ITEM_CHECKED: "buyer_checklist_item_checked",
  ITEM_UNCHECKED: "buyer_checklist_item_unchecked",
  COMPARE_SIMILAR_CLICKED: "buyer_checklist_compare_similar_clicked",
  GUIDE_CLICKED: "buyer_checklist_guide_clicked",
  CONTACT_REMINDER_VIEWED: "buyer_checklist_contact_reminder_viewed",
};

export const CHECKLIST_PREVIEW_COPY_ES = {
  heading: "Antes de comprar, revisa esto",
  subheading: "Usa esta lista para hacer mejores preguntas antes de visitar o separar el vehículo.",
  fullCta: "Ver checklist completo",
  compareSimilar: "Comparar con vehículos similares",
  viewSimilar: "Ver opciones similares",
};

export function getChecklistStorageKey(listingId) {
  if (!listingId) return CHECKLIST_STORAGE_KEYS.general;
  return `${CHECKLIST_STORAGE_KEYS.listingPrefix}${listingId}`;
}

export function trackBuyerChecklistEvent(eventType, metadata = {}) {
  const { trackBuyerChecklistEvent: track } = require("../utils/buyerChecklistAnalytics");
  return track(eventType, metadata);
}
